// CacheKey aee64ff1c6f28ab087eab669ba9a0677
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ACCOUNT_STRATEGY": {
    data_view: {
      default_name: {
        patients_search: "Accounts Search"
      },
      headers: {
        defaults: {
          captain: {
            name: "Advisor Name",
            email: "Advisor Email"
          },
          comment: {
            related_encounter_id: "Product ID"
          },
          encounter: {
            arrival_date: "Product Launch Date",
            discharge_date: "Product End Date",
            encounter_class_str: "Product Class Str",
            encounter_id: "Product ID",
            room: "Product Family"
          },
          issue: {
            related_encounter_id: "Product ID"
          },
          patient: {
            inverted_name: "Facility, System",
            date_of_birth: "Date of First Contract Signature",
            date_of_death: "End of Term Date",
            gender: "Account Type",
            primary_language: "Salesforce Account ID"
          },
          unit: {
            facility: "Building"
          }
        },
        workflows_view: {
          patient: {
            name: "Account"
          }
        }
      }
    }
  }
}

